import React from "react";
import {
  Header,
  Home,
  About,
  Experience,
  Projects,
  Contact,
} from "../components";

export default function Layout() {
  return (
    <>
      <Header />
      <Home />
      <About />
      <Experience />
      <Projects />
      <Contact />
    </>
  );
}
